import React from 'react';
import { useTranslation } from 'react-i18next';
import TableGrid, { Body, Cell, Footer, Head, Row } from 'layout/atoms/TableGrid';
import Grid from 'layout/molecules/Grid/Grid';
const COLUMNS = [
    ['80px', '1fr'],
    ['120px', '2fr'],
    ['80px', '1fr'],
    ['120px', '2fr'],
    ['100px', '1fr'],
    ['100px', '1fr'],
    ['100px', '1fr'],
    ['60px', '60px'],
];
function WarehouseReleasesList({ pagination, children }) {
    const { t } = useTranslation(['common', 'warehouseReleases']);
    return (React.createElement(TableGrid, { columns: COLUMNS },
        React.createElement(Head, null,
            React.createElement(Row, { head: true },
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:number')),
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:specification')),
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:volume_total')),
                React.createElement(Cell, { align: "left" }, t('warehouseReleases:receiver')),
                React.createElement(Cell, { align: "left" }, t('status')),
                React.createElement(Cell, { align: "left" }, t('created_date')),
                React.createElement(Cell, { align: "left" }, t('modified_date')),
                React.createElement(Cell, null))),
        React.createElement(Body, null, children),
        pagination && (React.createElement(Footer, null,
            React.createElement(Grid, { hp: 12 }, pagination)))));
}
export default WarehouseReleasesList;
